<template>
  <div class="app-wrapper" v-bind:class="{ closed: menu_opened }">

    <SideNavigation @menu-toggled="menu_toggled"/>
   
    <div class="wrapper">
      <TopNavigation/>
      <Entity/>

    <div class="input-group label">
      <label> Enter lease as </label>
      <select>
        <option value="0" selected disabled> Choose </option>
        <option value="tenant"> Tenant </option>
        <option value="lessor"> Lessor </option>
      </select>
    </div><!-- end of input-group -->

    <div class="input-group label">
      <label> Signing date </label>
      <input type="date">
      <span class="iconify icon icon:fe:calendar"></span>
    </div><!-- end of input-group -->

    <div class="input-group label">
      <label> Lease start date </label>
      <input type="date">
      <span class="iconify icon icon:fe:calendar"></span>
    </div><!-- end of input-group -->

    <div class="input-group label">
      <label> Lease term </label>
      <div class="row">
        <input type="number" placeholder="Enter a value" class="no-icon">
        <div class="radio-wrapper">
          
          <label>
            <div class="radio-container">
              <input type="radio" name="lease_term" checked>
              <span> Days </span>
            </div>
          </label>
          
          <label>
            <div class="radio-container">
              <input type="radio" name="lease_term">
              <span> Months </span>
            </div>
          </label>
          
          <label>
            <div class="radio-container">
              <input type="radio" name="lease_term">
              <span> Years </span>
            </div>
          </label>

        </div><!-- end of radio-wrapper -->
      </div><!-- end of row -->
    </div><!-- end of input-group -->

    <div class="input-group label">
      <label> Option to extend Lease time </label>
      <select v-model="extend_lease">
        <option value="no" selected> No </option>
        <option value="yes"> Yes </option>
      </select>
    </div><!-- end of input-group -->
    
    <div class="input-group label toggle-wrapper" v-if="extend_lease == 'yes'">
      <label> Prolongation time </label>
      <div class="row">
        <input type="number" placeholder="Enter a value" class="no-icon">
        <div class="radio-wrapper">
          <label>
            <div class="radio-container">
              <input type="radio" name="extend_lease" checked>
              <span> Days </span>
            </div>
          </label>

          <label>
            <div class="radio-container">
              <input type="radio" name="extend_lease">
              <span> Months </span>
            </div>
          </label>

          <label>
            <div class="radio-container">
              <input type="radio" name="extend_lease">
              <span> Annual </span>
            </div>
          </label>
        </div><!-- end of radio-wrapper -->
      </div><!-- end of row -->
    </div><!-- end of input-group -->

    <div class="input-group label">
      <label> Lease end </label>
      <input type="date">
      <span class="iconify icon icon:fe:calendar"></span>
    </div><!-- end of input-group -->
    
    <div class="input-group label">
      <label> Nature of the Lease </label>
      <select>
        <option value="0" selected disabled> Select one ... </option>
        <option value="real_estate"> Real Estate </option>
        <option value="equipment"> Equipment </option>
        <option value="vehicle"> Vehicle </option>
        <option value="other"> Other </option>
      </select>
    </div><!-- end of input-group -->

    <button class="step" @click="$router.push('commercial-terms')"> Next step </button>
    </div>
    
  </div>
</template>

<script>
import TopNavigation from '@/components/navigation/Top_navigation'
import SideNavigation from '@/components/navigation/Side_navigation'
import Entity from '@/components/form/Entity'

export default {
  components: {
    TopNavigation,
    SideNavigation,
    Entity
  },
  data() {
    return {
      menu_opened: false,
      extend_lease: 'no',
    }
  },
  methods: {
    menu_toggled() {this.menu_opened = !this.menu_opened} 
  }
}
</script>

<style scoped>
  .step {
    width: fit-content;
    margin: 20px auto 0;
    padding: 15px 35px;
  }
</style>